import { TaskFieldSection, TaskSectionPropertiesBase } from '../task-section';

export interface TaskPrioritySectionValue {
  priority: TaskPriorityType;
}

export enum TaskPriorityType {
  None = 'None',
  Low = 'Low',
  Normal = 'Normal',
  High = 'High',
  Critical = 'Critical',
}

export interface TaskPriorityOption {
  value: TaskPriorityType;
  label: string;
}

export interface TaskPrioritySectionProperties extends TaskSectionPropertiesBase {
  defaultValue: string;
  availablePriorities: TaskPriorityType[];
}

export type TaskPrioritySection = TaskFieldSection<TaskPrioritySectionProperties>;

export interface TaskFileUploadSectionProperties extends TaskSectionPropertiesBase {
  maxNumberOfFiles: number;
}

export type TaskFileUploadSection = TaskFieldSection<TaskFileUploadSectionProperties>;
